// Generated by ReScript, PLEASE EDIT WITH CARE


function isPending(future) {
  var match = future.status;
  if (typeof match === "object") {
    return match.NAME === "Pending";
  } else {
    return false;
  }
}

function isCancelled(future) {
  var match = future.status;
  if (typeof match === "object") {
    return false;
  } else {
    return true;
  }
}

function isResolved(future) {
  var match = future.status;
  if (typeof match === "object") {
    return match.NAME !== "Pending";
  } else {
    return false;
  }
}

function value(value$1) {
  return {
          status: {
            NAME: "Resolved",
            VAL: value$1
          }
        };
}

function run(callbacks, value) {
  callbacks.forEach(function (callback) {
        callback(value);
      });
}

function make(init) {
  var pendingPayload = {
    resolveCallbacks: undefined,
    cancelCallbacks: undefined,
    cancel: undefined
  };
  var future = {
    status: {
      NAME: "Pending",
      VAL: pendingPayload
    }
  };
  var resolver = function (value) {
    var match = future.status;
    if (typeof match !== "object") {
      return ;
    }
    if (match.NAME !== "Pending") {
      return ;
    }
    future.status = {
      NAME: "Resolved",
      VAL: value
    };
    var resolveCallbacks = match.VAL.resolveCallbacks;
    if (resolveCallbacks !== undefined) {
      return run(resolveCallbacks, value);
    }
    
  };
  pendingPayload.cancel = init(resolver);
  return future;
}

function makePure(init) {
  return make(function (resolve) {
              init(resolve);
            });
}

function get(future, func) {
  var match = future.status;
  if (typeof match !== "object") {
    return ;
  }
  if (match.NAME !== "Pending") {
    return func(match.VAL);
  }
  var pendingPayload = match.VAL;
  var resolveCallbacks = pendingPayload.resolveCallbacks;
  if (resolveCallbacks !== undefined) {
    resolveCallbacks.push(func);
    return ;
  }
  var resolveCallbacks$1 = [func];
  pendingPayload.resolveCallbacks = resolveCallbacks$1;
}

function onCancel(future, func) {
  var match = future.status;
  if (typeof match !== "object") {
    return func();
  }
  if (match.NAME !== "Pending") {
    return ;
  }
  var pendingPayload = match.VAL;
  var cancelCallbacks = pendingPayload.cancelCallbacks;
  if (cancelCallbacks !== undefined) {
    cancelCallbacks.push(func);
    return ;
  }
  var cancelCallbacks$1 = [func];
  pendingPayload.cancelCallbacks = cancelCallbacks$1;
}

function cancel(future) {
  var match = future.status;
  if (typeof match !== "object") {
    return ;
  }
  if (match.NAME !== "Pending") {
    return ;
  }
  var pendingPayload = match.VAL;
  future.status = "Cancelled";
  var cancel$1 = pendingPayload.cancel;
  if (cancel$1 !== undefined) {
    cancel$1();
  }
  var cancelCallbacks = pendingPayload.cancelCallbacks;
  if (cancelCallbacks !== undefined) {
    return run(cancelCallbacks, undefined);
  }
  
}

function map(source, propagateCancelOpt, f) {
  var propagateCancel = propagateCancelOpt !== undefined ? propagateCancelOpt : false;
  var future = make(function (resolve) {
        get(source, (function (value) {
                resolve(f(value));
              }));
        if (propagateCancel) {
          return (function () {
                    cancel(source);
                  });
        }
        
      });
  onCancel(source, (function () {
          cancel(future);
        }));
  return future;
}

function flatMap(source, propagateCancelOpt, f) {
  var propagateCancel = propagateCancelOpt !== undefined ? propagateCancelOpt : false;
  var pendingPayload = {
    resolveCallbacks: undefined,
    cancelCallbacks: undefined,
    cancel: undefined
  };
  var future = {
    status: {
      NAME: "Pending",
      VAL: pendingPayload
    }
  };
  get(source, (function (value) {
          var source$p = f(value);
          get(source$p, (function (value) {
                  future.status = {
                    NAME: "Resolved",
                    VAL: value
                  };
                  var resolveCallbacks = pendingPayload.resolveCallbacks;
                  if (resolveCallbacks !== undefined) {
                    return run(resolveCallbacks, value);
                  }
                  
                }));
          onCancel(source$p, (function () {
                  cancel(future);
                }));
        }));
  if (propagateCancel) {
    pendingPayload.cancel = (function () {
        cancel(source);
      });
  }
  onCancel(source, (function () {
          cancel(future);
        }));
  return future;
}

function tap(future, f) {
  get(future, f);
  return future;
}

function tapOk(future, f) {
  get(future, (function (result) {
          if (result.TAG === "Ok") {
            return f(result._0);
          }
          
        }));
  return future;
}

function tapError(future, f) {
  get(future, (function (result) {
          if (result.TAG === "Ok") {
            return ;
          } else {
            return f(result._0);
          }
        }));
  return future;
}

function mapResult(future, propagateCancel, f) {
  return map(future, propagateCancel, (function (result) {
                if (result.TAG === "Ok") {
                  return f(result._0);
                } else {
                  return {
                          TAG: "Error",
                          _0: result._0
                        };
                }
              }));
}

function mapOk(future, propagateCancel, f) {
  return map(future, propagateCancel, (function (result) {
                if (result.TAG === "Ok") {
                  return {
                          TAG: "Ok",
                          _0: f(result._0)
                        };
                } else {
                  return {
                          TAG: "Error",
                          _0: result._0
                        };
                }
              }));
}

function mapError(future, propagateCancel, f) {
  return map(future, propagateCancel, (function (result) {
                if (result.TAG === "Ok") {
                  return {
                          TAG: "Ok",
                          _0: result._0
                        };
                } else {
                  return {
                          TAG: "Error",
                          _0: f(result._0)
                        };
                }
              }));
}

function flatMapOk(future, propagateCancel, f) {
  return flatMap(future, propagateCancel, (function (result) {
                if (result.TAG === "Ok") {
                  return f(result._0);
                } else {
                  return {
                          status: {
                            NAME: "Resolved",
                            VAL: {
                              TAG: "Error",
                              _0: result._0
                            }
                          }
                        };
                }
              }));
}

function flatMapError(future, propagateCancel, f) {
  return flatMap(future, propagateCancel, (function (result) {
                if (result.TAG === "Ok") {
                  return {
                          status: {
                            NAME: "Resolved",
                            VAL: {
                              TAG: "Ok",
                              _0: result._0
                            }
                          }
                        };
                } else {
                  return f(result._0);
                }
              }));
}

function all2(param) {
  var b = param[1];
  var a = param[0];
  return makePure(function (resolve) {
              get(a, (function (a$p) {
                      get(b, (function (b$p) {
                              resolve([
                                    a$p,
                                    b$p
                                  ]);
                            }));
                    }));
            });
}

function all3(param) {
  var c = param[2];
  var b = param[1];
  var a = param[0];
  return makePure(function (resolve) {
              get(all2([
                        a,
                        b
                      ]), (function (param) {
                      var b$p = param[1];
                      var a$p = param[0];
                      get(c, (function (c$p) {
                              resolve([
                                    a$p,
                                    b$p,
                                    c$p
                                  ]);
                            }));
                    }));
            });
}

function all4(param) {
  var d = param[3];
  var c = param[2];
  var b = param[1];
  var a = param[0];
  return makePure(function (resolve) {
              get(all3([
                        a,
                        b,
                        c
                      ]), (function (param) {
                      var c$p = param[2];
                      var b$p = param[1];
                      var a$p = param[0];
                      get(d, (function (d$p) {
                              resolve([
                                    a$p,
                                    b$p,
                                    c$p,
                                    d$p
                                  ]);
                            }));
                    }));
            });
}

function all5(param) {
  var e = param[4];
  var d = param[3];
  var c = param[2];
  var b = param[1];
  var a = param[0];
  return makePure(function (resolve) {
              get(all4([
                        a,
                        b,
                        c,
                        d
                      ]), (function (param) {
                      var d$p = param[3];
                      var c$p = param[2];
                      var b$p = param[1];
                      var a$p = param[0];
                      get(e, (function (e$p) {
                              resolve([
                                    a$p,
                                    b$p,
                                    c$p,
                                    d$p,
                                    e$p
                                  ]);
                            }));
                    }));
            });
}

function all6(param) {
  var f = param[5];
  var e = param[4];
  var d = param[3];
  var c = param[2];
  var b = param[1];
  var a = param[0];
  return makePure(function (resolve) {
              get(all5([
                        a,
                        b,
                        c,
                        d,
                        e
                      ]), (function (param) {
                      var e$p = param[4];
                      var d$p = param[3];
                      var c$p = param[2];
                      var b$p = param[1];
                      var a$p = param[0];
                      get(f, (function (f$p) {
                              resolve([
                                    a$p,
                                    b$p,
                                    c$p,
                                    d$p,
                                    e$p,
                                    f$p
                                  ]);
                            }));
                    }));
            });
}

function all(futures) {
  var length = futures.length;
  var _i = 0;
  var _acc = {
    status: {
      NAME: "Resolved",
      VAL: []
    }
  };
  while(true) {
    var acc = _acc;
    var i = _i;
    if (i >= length) {
      return acc;
    }
    var acc$1 = flatMap(futures[i], undefined, (function(acc){
        return function (value) {
          return map(acc, undefined, (function (xs) {
                        xs.push(value);
                        return xs;
                      }));
        }
        }(acc)));
    _acc = acc$1;
    _i = i + 1 | 0;
    continue ;
  };
}

export {
  isPending ,
  isCancelled ,
  isResolved ,
  value ,
  make ,
  makePure ,
  get ,
  cancel ,
  onCancel ,
  map ,
  flatMap ,
  tap ,
  mapResult ,
  mapOk ,
  mapError ,
  flatMapOk ,
  flatMapError ,
  tapOk ,
  tapError ,
  all2 ,
  all3 ,
  all4 ,
  all5 ,
  all6 ,
  all ,
}
/* No side effect */
